import { render, staticRenderFns } from "./organization-firm-view.vue?vue&type=template&id=1c4fb877&scoped=true&"
import script from "./organization-firm-view.vue?vue&type=script&lang=js&"
export * from "./organization-firm-view.vue?vue&type=script&lang=js&"
import style0 from "./organization-firm-view.vue?vue&type=style&index=0&id=1c4fb877&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4fb877",
  null
  
)

export default component.exports